import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get, includes } from "lodash";
import React from "react";

const StyledContainer = styled("div")({
    display: "flex",
    width: "100%",
});

const StyledContentWrapper = styled("div")({
    flex: "1 1 auto",
    padding: "16px",
    border: "2px dashed #dbdbdb",
    marginTop: "15px",
});

const StyledPropertyManagement = styled("div")({
    textAlign: "center",
    fill: "#9e9e9e",
});

const StyledPropertyManagementHeader = styled("h4")({
    textAlign: "center",
    fill: "#9e9e9e",
});

const PropertyAddAssetServicesDataComponent = (props) => {
    const { role, addPropertyManagementSection, property } = props;

    return (
        <React.Fragment>
            <StyledContainer>
                <StyledContentWrapper>
                    <StyledPropertyManagement>
                        <StyledPropertyManagementHeader>There is no asset services data</StyledPropertyManagementHeader>
                        {includes(["transition", "dataAdmin", "dataEntry"], role) && (
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={() => addPropertyManagementSection(get(property, "propertyKey", null))}
                            >
                                Add Asset Services Data
                            </Button>
                        )}
                    </StyledPropertyManagement>
                </StyledContentWrapper>
            </StyledContainer>
        </React.Fragment>
    );
};

export default PropertyAddAssetServicesDataComponent;
